import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './styles/global.css';
import Header from './components/Header';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import DashboardLogin from './pages/DashboardLogin';
import Dashboard from './pages/Dashboard';
import DashboardAnnouncements from './pages/DashboardAnnouncements';
import DashboardEvents from './pages/DashboardEvents';
import DashboardFiles from './pages/DashboardFiles';
import DashboardPeople from './pages/DashboardPeople';
import DashboardTeams from './pages/DashboardTeams';
import DashboardMinistries from './pages/DashboardMinistries';
import DashboardReports from './pages/DashboardReports';
import { AuthProvider } from './context/AuthContext';
import TeamDetail from './pages/TeamDetail';
import MinistryDetail from './pages/MinistryDetail';
import DashboardOrganization from './pages/DashboardOrganization';
import DashboardAdmin from './pages/DashboardAdmin';
import DashboardAdminOrganizationCreate from './pages/DashboardAdminOrganizationCreate';
import DashboardAdminUserManagement from './pages/DashboardAdminUserManagement';
import DashboardAdminOrganizationManagement from './pages/DashboardAdminOrganizationManagement';
import DashboardAdminOrganizationEdit from './pages/DashboardAdminOrganizationEdit';
import PlanDetail from './pages/PlanDetail';
import DashboardNotifications from './pages/DashboardNotifications';
import ForgotPassword from './pages/ForgotPassword';
import DashboardSubscription from './pages/DashboardSubscription';
import { ThemeProvider } from './contexts/ThemeContext';

function App() {
	return (
		<AuthProvider>
			<ThemeProvider>
				<Router>
					<div className='App'>
						<Header />
						<Routes>
							<Route
								path='/'
								element={<Home />}
							/>
							<Route
								path='/about'
								element={<About />}
							/>
							<Route
								path='/contact'
								element={<Contact />}
							/>
							<Route
								path='/dashboard/login'
								element={<DashboardLogin />}
							/>
							<Route
								path='/dashboard'
								element={<Dashboard />}
							/>
							<Route
								path='/dashboard/announcements'
								element={<DashboardAnnouncements />}
							/>
							<Route
								path='/dashboard/events'
								element={<DashboardEvents />}
							/>
							<Route
								path='/dashboard/files'
								element={<DashboardFiles />}
							/>
							<Route
								path='/dashboard/people'
								element={<DashboardPeople />}
							/>
							<Route
								path='/dashboard/teams'
								element={<DashboardTeams />}
							/>
							<Route
								path='/dashboard/subscription'
								element={<DashboardSubscription />}
							/>
							<Route
								path='/dashboard/teams/:teamId'
								element={<TeamDetail />}
							/>
							<Route
								path='/dashboard/ministries'
								element={<DashboardMinistries />}
							/>
							<Route
								path='/dashboard/ministries/:ministryId'
								element={<MinistryDetail />}
							/>
							<Route
								path='/dashboard/reports'
								element={<DashboardReports />}
							/>
							<Route
								path='/dashboard/organization'
								element={<DashboardOrganization />}
							/>
							<Route
								path='/dashboard/admin'
								element={<DashboardAdmin />}
							/>
							<Route
								path='/dashboard/admin/organization/create'
								element={<DashboardAdminOrganizationCreate />}
							/>
							<Route
								path='/dashboard/admin/users'
								element={<DashboardAdminUserManagement />}
							/>
							<Route
								path='/dashboard/admin/organizations'
								element={
									<DashboardAdminOrganizationManagement />
								}
							/>
							<Route
								path='/dashboard/admin/organization/:id'
								element={<DashboardAdminOrganizationEdit />}
							/>
							<Route
								path='/plans/:planId'
								element={<PlanDetail />}
							/>
							<Route
								path='/dashboard/notifications'
								element={<DashboardNotifications />}
							/>
							<Route
								path='/forgot-password'
								element={<ForgotPassword />}
							/>
						</Routes>
					</div>
				</Router>
			</ThemeProvider>
		</AuthProvider>
	);
}

export default App;
